import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { getCoreAxiosInstance } from "../../api/CoreAxiosInstance";
import type { MyPayEnvironment } from "../../generated/core-api";
import { ComponentParameterSchema } from "../types";

/**
 * Bulk parameter discovery for multiple component names.
 *
 * POST /api/v1/christmas/companies/{companyCode}/components/parameters
 *   ?mypay_environment=…
 *   body: { componentNames: ["name1", "name2", …] }
 *
 * Returns a Record keyed by component display name → ComponentParameter[].
 */
export function useComponentsParameters(
  companyCode: string,
  deductionNames: string[],
  mypayEnvironment: MyPayEnvironment | null,
) {
  return useQuery({
    queryKey: [
      "pay-component-import",
      "componentsParameters",
      companyCode,
      deductionNames,
      mypayEnvironment,
    ],
    queryFn: async () => {
      const instance = await getCoreAxiosInstance();

      const { data } = await instance.post(
        `/api/v1/christmas/companies/${companyCode}/components/parameters`,
        { componentNames: deductionNames },
        { params: { mypay_environment: mypayEnvironment! } },
      );

      return z.record(z.array(ComponentParameterSchema)).parse(data);
    },
    enabled:
      !!companyCode && deductionNames.length > 0 && mypayEnvironment !== null,
  });
}
